import BaseComponent from '../base/baseComponent';
export default class Accordion extends BaseComponent {
    constructor(element) {
        super(element);
        this.summary = this._el.querySelector('summary');
        this.content = this._el.querySelector('.content');
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.summaryClick();
    }
    summaryClick() {
        this.summary.addEventListener('click', (e) => {
            e.preventDefault();
            this._el.style.overflow = 'hidden';
            if (this.isClosing || this._el.getAttribute('open') === null) {
                this.closeAll();
            }
            else if (this.isExpanding || this._el.getAttribute('open') !== null) {
                this.shrink();
            }
        });
    }
    shrink() {
        this.isClosing = true;
        const startHeight = `${this._el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight}px`;
        if (this.animation) {
            this.animation.cancel();
        }
        this.animation = this._el.animate({
            height: [startHeight, endHeight]
        }, {
            duration: 300,
            easing: 'ease-in-out'
        });
        this.animation.onfinish = () => this.onAnimationFinish(false);
        this.animation.oncancel = () => this.isClosing = false;
    }
    closeAll() {
        const openAccordions = [...document.querySelectorAll('details.accordion[open]')];
        let indexTriggerAnimation = 0;
        if (openAccordions && openAccordions.length > 0) {
            openAccordions.forEach((accordion) => {
                let startHeight = `${accordion.offsetHeight}px`;
                let endHeight = `${accordion.querySelector('summary').offsetHeight}px`;
                let animation = accordion.animate({
                    height: [startHeight, endHeight]
                }, {
                    duration: 300,
                    easing: 'ease-in-out'
                });
                animation.onfinish = () => {
                    indexTriggerAnimation += 1;
                    accordion.style.height = accordion.style.overflow = '';
                    accordion.removeAttribute('open');
                    accordion.querySelector('summary').setAttribute('aria-expanded', 'false');
                    if (indexTriggerAnimation === openAccordions.length) {
                        this.open();
                    }
                };
            });
        }
        else {
            this.open();
        }
    }
    onAnimationFinish(open) {
        if (open) {
            this._el.setAttribute('open', 'true');
            this.summary.setAttribute('aria-expanded', 'true');
        }
        else {
            this._el.removeAttribute('open');
            this.summary.setAttribute('aria-expanded', 'false');
        }
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this._el.style.height = this._el.style.overflow = '';
    }
    open() {
        this._el.style.height = `${this._el.offsetHeight}px`;
        this._el.setAttribute('open', 'true');
        this.summary.setAttribute('aria-expanded', 'true');
        window.requestAnimationFrame(() => this.expand());
    }
    expand() {
        this.isExpanding = true;
        const startHeight = `${this._el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
        if (this.animation) {
            this.animation.cancel();
        }
        this.animation = this._el.animate({
            height: [startHeight, endHeight]
        }, {
            duration: 300,
            easing: 'ease-in-out'
        });
        this.animation.onfinish = () => this.onAnimationFinish(true);
        this.animation.oncancel = () => this.isExpanding = false;
    }
}
